import { createSlice } from "@reduxjs/toolkit";


export const SelectGameTime2d = ({ gameInfo2dSlice }) => gameInfo2dSlice.gameTimer
export const SelectCurrentGameTime = ({ gameInfo2dSlice }) => gameInfo2dSlice.current_game_time
export const SelectNextGameTime = ({ gameInfo2dSlice }) => gameInfo2dSlice.next_game_time
export const SelectCoupenValue = ({ gameInfo2dSlice }) => gameInfo2dSlice.coupen_value
export const SelectUserWallet = ({ gameInfo2dSlice }) => gameInfo2dSlice.user_wallet
export const SelectLastWinCard = ({ gameInfo2dSlice }) => gameInfo2dSlice.last_win_Card
export const SelectTimeSlot = ({ gameInfo2dSlice }) => gameInfo2dSlice.TIME_SLOT
export const SelectAdvanceDrawSelectTime = ({ gameInfo2dSlice }) => gameInfo2dSlice.ADVANCE_DRAW_SELECT_TIME
export const SelectLastSaleAmount = ({ gameInfo2dSlice }) => gameInfo2dSlice.last_sale_amount
export const SelectLastTicketId = ({ gameInfo2dSlice }) => gameInfo2dSlice.last_ticket_id
export const SelectLotteryReport = ({ gameInfo2dSlice }) => gameInfo2dSlice.lottery_Report
export const SelectClaimTicket = ({ gameInfo2dSlice }) => gameInfo2dSlice.claim_ticket_id
export const SelectClaimTicketRecord = ({ gameInfo2dSlice }) => gameInfo2dSlice.claim_ticket_record
export const SelectReprintList = ({ gameInfo2dSlice }) => gameInfo2dSlice.rePrint_list
export const SelectResultData = ({ gameInfo2dSlice }) => gameInfo2dSlice.result_data
export const SelectAutoResultData = ({ gameInfo2dSlice }) => gameInfo2dSlice.autoResultData
export const SelectAnnoucements = ({ gameInfo2dSlice }) => gameInfo2dSlice.annoucements
export const SelectPreviewsTime = ({ gameInfo2dSlice }) => gameInfo2dSlice.previews_game_time
export const SelectGameID = ({ gameInfo2dSlice }) => gameInfo2dSlice.game_id
export const SelectWinLoseRecord = ({ gameInfo2dSlice }) => gameInfo2dSlice.win_lose
export const SelectPrintData = ({ gameInfo2dSlice }) => gameInfo2dSlice.Print_data


const gameInfo2dSlice = createSlice({
    name: "gameInfo2dSlice",
    initialState: {
        gameTimer: true,
        current_game_time: null,
        next_game_time: null,
        coupen_value: null,
        user_wallet: 0,
        last_win_Card: [],
        Print_data:[],
        TIME_SLOT: [],
        ADVANCE_DRAW_SELECT_TIME: [],
        last_sale_amount: null,
        last_ticket_id: null,
        lottery_Report: [],
        claim_ticket_id: '',
        claim_ticket_record: {},
        rePrint_list: [],
        result_data: [],
        autoResultData: [],
        annoucements: '',
        previews_game_time: null,
        game_id: '',
          win_lose: {}
    },
    reducers: {
        SET_GAME_TIMER: (state, { payload }) => { state.gameTimer = payload },
        SET_CURRENT_GAME_TIME: (state, { payload }) => { state.current_game_time = payload },
        SET_NEXT_GAME_TIME: (state, { payload }) => { state.next_game_time = payload },
        SET_COUPEN_VALUE: (state, { payload }) => { state.coupen_value = payload },
        SET_USER_WALLET: (state, { payload }) => { state.user_wallet = payload },
        SET_LAST_WIN_CARD: (state, { payload }) => { state.last_win_Card = [...payload] },
        SET_TIME_SLOT: (state, { payload }) => { state.TIME_SLOT = [...payload] },
        SET_ADVANCE_DRAW_SELECT_TIME: (state, { payload }) => { state.ADVANCE_DRAW_SELECT_TIME = [...payload] },
        SET_LAST_SALE_AMOUNT: (state, { payload }) => { state.last_sale_amount = payload },
        SET_LAST_TICKET_ID: (state, { payload }) => { state.last_ticket_id = payload },
        SET_LOTTERY_REPORT: (state, { payload }) => { state.lottery_Report = [...payload] },
        SET_CLAIM_TICKET_ID: (state, { payload }) => { state.claim_ticket_id = payload },
        SET_CLAIM_TICKET_RECORD: (state, { payload }) => { state.claim_ticket_record = { ...payload } },
        SET_REPRNT_LIST: (state, { payload }) => { state.rePrint_list = [...payload] },
        SET_RESULT_DATA: (state, { payload }) => { state.result_data = [...payload] },
        SET_AUTO_RESULT_DATA: (state, { payload }) => { state.autoResultData = [...payload] },
        SET_ANNOUCEMENTS: (state, { payload }) => { state.annoucements = payload },
        SET_PREVIEWS_GAME_TIME: (state, { payload }) => { state.previews_game_time = payload },
        SET_TR_CODE: (state, { payload }) => { state.game_id = payload },
        SET_WIN_LOSE_RECORD: (state, { payload }) => { state.win_lose = payload },
        SET_PRINT_DATA: (state, { payload }) => { state.Print_data = payload },
        clearWinLoseRecord: (state) => {
                state.win_lose = {};
            }
    }
})





export const {
    SET_GAME_TIMER, SET_CURRENT_GAME_TIME, SET_NEXT_GAME_TIME,
    SET_COUPEN_VALUE, SET_USER_WALLET, SET_LAST_WIN_CARD, SET_TIME_SLOT,
    SET_ADVANCE_DRAW_SELECT_TIME, SET_LAST_SALE_AMOUNT, SET_LAST_TICKET_ID,
    SET_LOTTERY_REPORT, SET_CLAIM_TICKET_ID, SET_CLAIM_TICKET_RECORD,
    SET_REPRNT_LIST, SET_RESULT_DATA, SET_AUTO_RESULT_DATA, SET_ANNOUCEMENTS,
    SET_PREVIEWS_GAME_TIME, SET_TR_CODE, SET_WIN_LOSE_RECORD,SET_PRINT_DATA,clearWinLoseRecord

} = gameInfo2dSlice.actions;

export default gameInfo2dSlice.reducer;